/**
 * 图标统一出口。
 *
 * 规则：全站只用 Phosphor 一套图标族，粗细由一个常量统一控制。
 * 手写 SVG path 一律禁止：形状容易画歪，也没有统一的视觉重量。
 * 用 name 而不是直接 import 图标组件，是为了将来换图标族时只改这里。
 */

import type { Icon as PhosphorIcon, IconProps } from '@phosphor-icons/react';
import {
	ArrowClockwise,
	Camera,
	CaretDown,
	CaretRight,
	CaretUpDown,
	Check,
	CheckCircle,
	CircleHalfTilt,
	Clock,
	ClockCountdown,
	CookingPot,
	Copy,
	ForkKnife,
	GearSix,
	House,
	Info,
	Key,
	Leaf,
	MagnifyingGlass,
	Microphone,
	PencilSimple,
	Plus,
	Receipt,
	ShoppingCart,
	SignOut,
	Snowflake,
	Sparkle,
	Star,
	Ticket,
	Trash,
	Users,
	WarningCircle,
	X,
} from '@phosphor-icons/react';

/** 统一图标粗细。改这一个值，全站图标重量一起变。 */
export const ICON_WEIGHT = 'regular' satisfies IconProps['weight'];

export const GLYPHS = {
	// 导航
	fridge: Snowflake,
	cook: CookingPot,
	buy: ShoppingCart,
	settings: GearSix,
	// 录入
	manual: PencilSimple,
	receipt: Receipt,
	voice: Microphone,
	// 操作
	add: Plus,
	close: X,
	check: Check,
	next: CaretRight,
	down: CaretDown,
	swap: CaretUpDown,
	delete: Trash,
	edit: PencilSimple,
	favorite: Star,
	refresh: ArrowClockwise,
	search: MagnifyingGlass,
	copy: Copy,
	signOut: SignOut,
	// 冰箱与成员
	house: House,
	key: Key,
	invite: Ticket,
	users: Users,
	// 状态
	warn: WarningCircle,
	ok: CheckCircle,
	info: Info,
	sparkle: Sparkle,
	clock: Clock,
	countdown: ClockCountdown,
	fresh: Leaf,
	flavor: ForkKnife,
	theme: CircleHalfTilt,
} as const;

export interface IconGlyphProps extends Omit<IconProps, 'weight'> {
	glyph: PhosphorIcon;
	/** 默认沿用统一粗细 */
	weight?: IconProps['weight'];
}

export function IconGlyph({ glyph: Glyph, weight = ICON_WEIGHT, ...rest }: IconGlyphProps) {
	return <Glyph weight={weight} {...rest} />;
}
